import { apiClient } from '@/lib/api-client';
import { PROFILES_ENDPOINTS } from '../constants';
import type { ProfileInput, ProfilesListResponse, PublicProfile } from '../types';

/** Chamadas HTTP dos perfis de acesso. */
export const profilesService = {
  list(params: { page: number; perPage?: number; search?: string }) {
    const query = new URLSearchParams({
      page: String(params.page),
      perPage: String(params.perPage ?? 20),
    });

    if (params.search) query.set('search', params.search);

    return apiClient.get<ProfilesListResponse>(`${PROFILES_ENDPOINTS.LIST}?${query.toString()}`);
  },

  get(id: string) {
    return apiClient.get<PublicProfile>(PROFILES_ENDPOINTS.detail(id));
  },

  create(input: ProfileInput) {
    return apiClient.post<PublicProfile>(PROFILES_ENDPOINTS.LIST, input);
  },

  update(id: string, input: Partial<ProfileInput>) {
    return apiClient.patch<PublicProfile>(PROFILES_ENDPOINTS.detail(id), input);
  },

  remove(id: string) {
    return apiClient.delete<{ message: string }>(PROFILES_ENDPOINTS.detail(id));
  },
};
